// HiddenField.js
import React from 'react';

const HiddenField = ({ key, value }) => {
  return (
    <input type="hidden" name={key} defaultValue={value} />
  );
};

export default HiddenField;
